import { defineComponent, ref, computed, onMounted, reactive } from 'vue';
import Sidebar from '@/components/Sidebar.vue';
import Header from '@/components/HeaderDashboard.vue';
import Swal from 'sweetalert2';
import { SearchIcon, PlusIcon, TrashIcon, ShoppingCartIcon, CheckCircleIcon, XIcon, ListIcon, UserIcon, EditIcon } from 'lucide-vue-next';
import { OrdenVentaService } from '@/services/OrdenVentaService';
import { MaestrosService } from '@/services/MaestrosService';
import { config } from "@/config";
export default defineComponent({
    name: 'VentasRetailPos',
    components: {
        Sidebar, Header,
        SearchIcon, PlusIcon, TrashIcon, ShoppingCartIcon, CheckCircleIcon, XIcon, ListIcon, UserIcon, EditIcon
    },
    setup() {
        const searchQuery = ref('');
        const searchOcurred = ref(false);
        const productos = ref([]);
        const clientes = ref([]);
        const sucursales = ref([]);
        const borradores = ref([]);
        const carrito = ref([]);
        const clienteSeleccionado = ref('');
        const searchClienteQuery = ref('');
        const showClientesDropdown = ref(false);
        const sucursalSeleccionada = ref('');
        const ordenBorradorActiva = ref(null);
        const showClientModal = ref(false);
        const guardandoCliente = ref(false);
        const nuevoCliente = ref({ documento: '', nombre: '', celular: '', telCelularPrefix: '+58', telCelularNumber: '', direccion: '', estadoId: 0, municipioId: 0, parroquiaId: 0, tipoDocumentoId: 1 });
        const showBorradores = ref(false);
        const maestros = reactive({ estados: [], municipios: [], parroquias: [], tiposDocumento: [] });
        const maestrosEdit = reactive({ municipios: [], parroquias: [] });
        const showEditClientModal = ref(false);
        const clienteEditando = ref({ id: 0, documento: '', nombre: '', celular: '', email: '', direccion: '', estadoId: 0, municipioId: 0, parroquiaId: 0, tipoDocumentoId: 1, tipoContribuyenteId: 1, tipoComercioId: 1 });
        onMounted(async () => {
            await cargarClientesYSucursales();
            await cargarListaBorradores();
            const resEst = await MaestrosService.getEstados();
            maestros.estados = resEst.datos || [];
            const resTiposDoc = await MaestrosService.getTiposDocumento();
            maestros.tiposDocumento = resTiposDoc.datos || [];
        });
        const getPrefix = (id) => {
            const doc = maestros.tiposDocumento.find((d) => d.tipoDocumentoId === id);
            if (!doc)
                return '';
            const desc = (doc.descripcion || '').toUpperCase();
            if (desc.includes('VENEZOLANO'))
                return 'V';
            if (desc.includes('EXTRANJERO'))
                return 'E';
            if (desc.includes('JURIDICO'))
                return 'J';
            if (desc.includes('RIF'))
                return 'RIF';
            if (desc.includes('PASAPORTE'))
                return 'P';
            const first = desc[0];
            if (['V', 'E', 'J', 'G', 'P'].includes(first))
                return first;
            return '';
        };
        const cleanDocumentoExpress = () => {
            const prefix = getPrefix(nuevoCliente.value.tipoDocumentoId);
            if (!prefix)
                return;
            const numbers = nuevoCliente.value.documento.split('-').pop()?.replace(/[^0-9]/g, '') || '';
            nuevoCliente.value.documento = `${prefix}-${numbers}`;
        };
        const updateDocumentoPrefixExpress = () => {
            const prefix = getPrefix(nuevoCliente.value.tipoDocumentoId);
            if (!prefix)
                return;
            const numbers = nuevoCliente.value.documento.split('-').pop()?.replace(/[^0-9]/g, '') || '';
            nuevoCliente.value.documento = `${prefix}-${numbers}`;
        };
        const placeholderDocExpress = computed(() => {
            const prefix = getPrefix(nuevoCliente.value.tipoDocumentoId);
            return prefix ? `Ej: ${prefix}-12345678` : 'Seleccione tipo primero...';
        });
        const onEstadoChange = async () => {
            nuevoCliente.value.municipioId = 0;
            nuevoCliente.value.parroquiaId = 0;
            const res = await MaestrosService.getMunicipiosByEstado(nuevoCliente.value.estadoId);
            maestros.municipios = res.datos || [];
        };
        const onMunicipioChange = async () => {
            nuevoCliente.value.parroquiaId = 0;
            const res = await MaestrosService.getParroquiasByMunicipio(nuevoCliente.value.municipioId);
            maestros.parroquias = res.datos || [];
        };
        const onEstadoEditChange = async () => {
            const res = await MaestrosService.getMunicipiosByEstado(clienteEditando.value.estadoId);
            maestrosEdit.municipios = res.datos || [];
            if (maestrosEdit.municipios.length > 0) {
                clienteEditando.value.municipioId = maestrosEdit.municipios[0].municipioId;
                await onMunicipioEditChange();
            }
        };
        const onMunicipioEditChange = async () => {
            const res = await MaestrosService.getParroquiasByMunicipio(clienteEditando.value.municipioId);
            maestrosEdit.parroquias = res.datos || [];
            if (maestrosEdit.parroquias.length > 0)
                clienteEditando.value.parroquiaId = maestrosEdit.parroquias[0].parroquiaId;
        };
        const abrirEditarCliente = async () => {
            if (!clienteSeleccionado.value)
                return;
            try {
                Swal.showLoading();
                const res = await fetch(`${config.API_URL}/api/ClienteAlMayor/${clienteSeleccionado.value}`, { headers: getAuth() });
                if (res.ok) {
                    const data = await res.json();
                    const c = data.datos;
                    clienteEditando.value = { id: c.clienteId, documento: c.documentoNumero, nombre: c.nombreRazonSocial, celular: c.telCelular1 || '', email: c.email || '', direccion: c.direccion, estadoId: c.estadoId, municipioId: c.municipioId, parroquiaId: c.parroquiaId, tipoDocumentoId: c.tipoDocumentoId, tipoContribuyenteId: c.tipoContribuyenteId, tipoComercioId: c.tipoComercioId || 1 };
                    const resMun = await MaestrosService.getMunicipiosByEstado(c.estadoId);
                    maestrosEdit.municipios = resMun.datos || [];
                    const resPar = await MaestrosService.getParroquiasByMunicipio(c.municipioId);
                    maestrosEdit.parroquias = resPar.datos || [];
                    Swal.close();
                    showEditClientModal.value = true;
                }
            }
            catch (e) {
                Swal.fire('Error', 'No se pudo cargar la información', 'error');
            }
        };
        const guardarEdicionCliente = async () => {
            try {
                guardandoCliente.value = true;
                const payload = { clienteId: clienteEditando.value.id, tipoDocumentoId: clienteEditando.value.tipoDocumentoId, documentoNumero: clienteEditando.value.documento, nombreRazonSocial: clienteEditando.value.nombre, tipoContribuyenteId: clienteEditando.value.tipoContribuyenteId, porcentajeRetencion: 0, direccion: clienteEditando.value.direccion, estadoId: clienteEditando.value.estadoId, municipioId: clienteEditando.value.municipioId, parroquiaId: clienteEditando.value.parroquiaId, telCelular1: clienteEditando.value.celular, email: clienteEditando.value.email, tipoComercioId: clienteEditando.value.tipoComercioId, sector: '.', ciudad: '.' };
                const res = await fetch(`${config.API_URL}/api/ClienteAlMayor/${clienteEditando.value.id}`, { method: 'PUT', headers: { ...getAuth(), 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
                if (res.ok) {
                    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Cliente Actualizado', showConfirmButton: false, timer: 1500 });
                    showEditClientModal.value = false;
                    searchClienteQuery.value = clienteEditando.value.nombre;
                }
                else {
                    Swal.fire('Atención', 'No se pudo guardar los cambios.', 'warning');
                }
            }
            catch (e) {
                Swal.fire('Error', 'Fallo de conexión.', 'error');
            }
            finally {
                guardandoCliente.value = false;
            }
        };
        const getAuth = () => ({ Authorization: `Bearer ${localStorage.getItem("accessToken")}` });
        const mapCliente = (c) => ({ id: c.clienteId, nombre: `${c.nombreRazonSocial} (${c.documentoNumero})` });
        let debounceTimer = null;
        const onSearchClientesInput = async () => {
            if (clienteSeleccionado.value !== '')
                clienteSeleccionado.value = '';
            showClientesDropdown.value = true;
            const query = searchClienteQuery.value;
            if (query.length === 0) {
                await cargarClientesBase();
                return;
            }
            if (query.length < 2)
                return;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(async () => {
                try {
                    const res = await fetch(`${config.API_URL}/api/ClienteAlMayor?search=${query}`, { headers: getAuth() });
                    if (res.ok) {
                        const data = await res.json();
                        clientes.value = (data.datos.items || data.datos).map(mapCliente);
                    }
                }
                catch (e) { }
            }, 400);
        };
        const hideClientesDropdown = () => setTimeout(() => { showClientesDropdown.value = false; }, 200);
        const seleccionarCliente = (id, nombre) => { clienteSeleccionado.value = id; searchClienteQuery.value = nombre; showClientesDropdown.value = false; };
        const cargarClientesBase = async () => {
            try {
                const res = await fetch(`${config.API_URL}/api/ClienteAlMayor?pageSize=20`, { headers: getAuth() });
                if (res.ok) {
                    const data = await res.json();
                    clientes.value = (data.datos.items || data.datos).map(mapCliente);
                }
            }
            catch (e) { }
        };
        const cargarClientesYSucursales = async () => {
            try {
                await cargarClientesBase();
                const sucRes = await fetch(`${config.API_URL}/api/Almacen/all-simple`, { headers: getAuth() });
                if (sucRes.ok) {
                    const sucData = await sucRes.json();
                    sucursales.value = sucData.datos.map((s) => ({ id: s.almacenId, nombre: s.nombre || s.nombreAlmacen }));
                }
                else {
                    sucursales.value = [{ id: 1, nombre: 'Principal' }];
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        const cargarListaBorradores = async () => {
            try {
                const res = await OrdenVentaService.getBorradores();
                if (res.exito && res.datos)
                    borradores.value = res.datos;
            }
            catch (e) { }
        };
        const buscarProductos = async () => {
            if (!searchQuery.value.trim())
                return;
            searchOcurred.value = true;
            try {
                const res = await fetch(`${config.API_URL}/api/Producto/pos/search?searchTerm=${searchQuery.value}`, { headers: getAuth() });
                if (res.ok) {
                    const data = await res.json();
                    productos.value = data.datos.map((p) => ({
                        id: p.id,
                        codigo: p.codigo,
                        nombre: p.nombre,
                        precioUsd: p.precioUsd,
                        precioOriginalUsd: p.precioOriginalUsd,
                        tienePromocion: p.tienePromocion,
                        porcentajeDescuento: p.porcentajeDescuento,
                        ahorroUsd: p.ahorroUsd,
                        stockTotal: p.stockTotal,
                        stockDetalle: p.stockDetalle,
                        cantidadAgregar: 1
                    }));
                }
                else {
                    productos.value = [];
                }
            }
            catch (error) {
                productos.value = [];
            }
        };
        const crearClienteExpress = async () => {
            try {
                guardandoCliente.value = true;
                const payload = {
                    tipoDocumentoId: nuevoCliente.value.tipoDocumentoId,
                    documentoNumero: nuevoCliente.value.documento,
                    nombreRazonSocial: nuevoCliente.value.nombre,
                    tipoContribuyenteId: 1,
                    tipoComercioId: 1,
                    porcentajeRetencion: 0,
                    direccion: nuevoCliente.value.direccion,
                    estadoId: nuevoCliente.value.estadoId,
                    municipioId: nuevoCliente.value.municipioId,
                    parroquiaId: nuevoCliente.value.parroquiaId,
                    telCelular1: `${nuevoCliente.value.telCelularPrefix}${nuevoCliente.value.telCelularNumber.trim()}`,
                    telefonoCelular: `${nuevoCliente.value.telCelularPrefix}${nuevoCliente.value.telCelularNumber.trim()}`,
                    ciudad: 'N/A',
                    sector: 'N/A',
                    usuarioRegistro: 'POS',
                    asignadoAId: 1,
                    regionId: 1
                };
                const res = await fetch(`${config.API_URL}/api/ClienteAlMayor`, { method: 'POST', headers: { ...getAuth(), 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
                if (res.ok) {
                    const resData = await res.json();
                    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Cliente Creado', showConfirmButton: false, timer: 1500 });
                    showClientModal.value = false;
                    await cargarClientesYSucursales();
                    if (resData && resData.datos && resData.datos.clienteId) {
                        seleccionarCliente(resData.datos.clienteId, `${resData.datos.nombreRazonSocial} (${resData.datos.documentoNumero})`);
                    }
                    else {
                        const encontrado = clientes.value.find(c => c.nombre.includes(nuevoCliente.value.nombre));
                        if (encontrado)
                            seleccionarCliente(encontrado.id, encontrado.nombre);
                    }
                }
                else {
                    Swal.fire('Atención', 'No se pudo crear. Revise si el documento ya existe.', 'warning');
                }
            }
            catch (e) {
                Swal.fire('Error', 'Fallo de conexión.', 'error');
            }
            finally {
                guardandoCliente.value = false;
            }
        };
        const agregarAlCarrito = (prod) => {
            if (prod.cantidadAgregar <= 0)
                return;
            const existing = carrito.value.find(c => c.productoId === prod.id);
            if (existing) {
                existing.cantidad += prod.cantidadAgregar;
            }
            else {
                carrito.value.push({ productoId: prod.id, nombre: prod.nombre, precioUnitarioUsd: prod.precioUsd, cantidad: prod.cantidadAgregar });
            }
            prod.cantidadAgregar = 1;
            Swal.fire({ toast: true, title: 'Añadido', icon: 'success', position: 'top-end', showConfirmButton: false, timer: 900 });
        };
        const quitarDelCarrito = (index) => carrito.value.splice(index, 1);
        const cancelarVenta = () => {
            Swal.fire({ title: '¿Vaciar ticket?', icon: 'warning', showCancelButton: true, confirmButtonText: 'Sí, vaciar', confirmButtonColor: '#ef4444' }).then(result => {
                if (result.isConfirmed) {
                    carrito.value = [];
                    clienteSeleccionado.value = '';
                    searchClienteQuery.value = '';
                    sucursalSeleccionada.value = '';
                    searchQuery.value = '';
                    productos.value = [];
                    searchOcurred.value = false;
                    ordenBorradorActiva.value = null;
                }
            });
        };
        const cargarBorrador = (orden) => {
            carrito.value = orden.detalles.map(d => ({ productoId: d.productoId, nombre: d.nombreProducto, precioUnitarioUsd: d.precioUnitarioUsd, cantidad: d.cantidad }));
            clienteSeleccionado.value = orden.clienteId;
            sucursalSeleccionada.value = orden.sucursalId;
            ordenBorradorActiva.value = orden.ordenVentaId;
            showBorradores.value = false;
            Swal.fire({ toast: true, title: 'Borrador cargado', icon: 'info', position: 'top', showConfirmButton: false, timer: 1500 });
        };
        const guardarBorrador = async () => {
            if (carrito.value.length === 0 || !clienteSeleccionado.value || !sucursalSeleccionada.value)
                return;
            try {
                Swal.showLoading();
                if (ordenBorradorActiva.value)
                    await OrdenVentaService.anular(ordenBorradorActiva.value);
                const data = { clienteId: clienteSeleccionado.value, sucursalId: sucursalSeleccionada.value, detalles: carrito.value.map(c => ({ productoId: c.productoId, cantidad: c.cantidad, precioUnitarioUsd: c.precioUnitarioUsd })) };
                const res = await OrdenVentaService.create(data);
                if (res.exito) {
                    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Pausado', text: `Orden: ${res.datos.codigoOrden}`, showConfirmButton: false, timer: 3000 });
                    carrito.value = [];
                    clienteSeleccionado.value = '';
                    searchClienteQuery.value = '';
                    sucursalSeleccionada.value = '';
                    searchQuery.value = '';
                    productos.value = [];
                    searchOcurred.value = false;
                    ordenBorradorActiva.value = null;
                    cargarListaBorradores();
                }
            }
            catch (error) { }
        };
        const procesarVenta = async () => {
            try {
                Swal.showLoading();
                if (ordenBorradorActiva.value)
                    await OrdenVentaService.anular(ordenBorradorActiva.value);
                const data = { clienteId: clienteSeleccionado.value, sucursalId: sucursalSeleccionada.value, detalles: carrito.value.map(c => ({ productoId: c.productoId, cantidad: c.cantidad, precioUnitarioUsd: c.precioUnitarioUsd })) };
                const res = await OrdenVentaService.create(data);
                if (res.exito) {
                    const id = res.datos.ordenVentaId;
                    await OrdenVentaService.cambiarEstado(id, 'EnCaja');
                    Swal.fire({ title: '¡Orden Enviada!', text: `La orden ${res.datos.codigoOrden} fue enviada a caja.`, icon: 'success', showCancelButton: true, confirmButtonText: 'Imprimir Comanda', cancelButtonText: 'Cerrar', confirmButtonColor: '#3b82f6' }).then(result => { if (result.isConfirmed)
                        imprimirComanda(res.datos); });
                    carrito.value = [];
                    clienteSeleccionado.value = '';
                    searchClienteQuery.value = '';
                    sucursalSeleccionada.value = '';
                    searchQuery.value = '';
                    productos.value = [];
                    searchOcurred.value = false;
                    ordenBorradorActiva.value = null;
                }
            }
            catch (error) {
                Swal.fire('Error', 'Problema al procesar pago', 'error');
            }
        };
        const totalCarrito = computed(() => carrito.value.reduce((acc, current) => acc + (current.precioUnitarioUsd * current.cantidad), 0));
        const imprimirComanda = (orden) => {
            const printWindow = window.open('', '_blank', 'width=400,height=600');
            if (!printWindow)
                return;
            const html = `<html><head><title>Comanda ${orden.codigoOrden}</title><style>body{font-family:'Courier New',monospace;width:80mm;padding:10px;margin:0}.header{text-align:center;border-bottom:1px dashed #000;padding-bottom:10px;margin-bottom:10px}.item{display:flex;justify-content:space-between;margin-bottom:5px;font-size:14px}.footer{border-top:1px dashed #000;margin-top:10px;padding-top:10px;text-align:center;font-size:12px}h2,h4{margin:5px 0}</style></head><body><div class="header"><h2>SURTIMOTOS</h2><h4>${orden.nombreSucursal || 'Almacén Principal'}</h4><p>Comanda: <strong>${orden.codigoOrden}</strong></p><p>Fecha: ${new Date(orden.fechaCreacion).toLocaleString()}</p></div><div><p><strong>Cliente:</strong> ${orden.nombreCliente}</p><div style="border-bottom:1px solid #000;margin:10px 0"></div>${orden.detalles.map(d => `<div class="item"><span>${d.nombreProducto}</span><strong>x${d.cantidad}</strong></div>`).join('')}</div><div class="footer"><p>*** COPIA PARA ALMACÉN ***</p></div></body></html>`;
            printWindow.document.write(html);
            printWindow.document.close();
            printWindow.print();
        };
        return {
            searchQuery, searchOcurred, productos, buscarProductos,
            agregarAlCarrito, carrito, quitarDelCarrito,
            clientes, clienteSeleccionado, sucursales, sucursalSeleccionada,
            searchClienteQuery, showClientesDropdown, onSearchClientesInput, hideClientesDropdown, seleccionarCliente,
            totalCarrito, cancelarVenta, procesarVenta, guardarBorrador,
            showClientModal, guardandoCliente, nuevoCliente, crearClienteExpress,
            maestros, onEstadoChange, onMunicipioChange, updateDocumentoPrefixExpress, cleanDocumentoExpress, placeholderDocExpress,
            showBorradores, borradores, cargarBorrador,
            showEditClientModal, clienteEditando, abrirEditarCliente, guardarEdicionCliente, maestrosEdit, onEstadoEditChange, onMunicipioEditChange,
            imprimirComanda
        };
    }
});
